import React, { useEffect, memo, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import "./index.scss";
import {useDispatch, useSelector} from "react-redux";
import {useRPC} from "../../hooks/rpc";
import {setScreenSaverStatusAction} from "../../store/control/actions";
import {onClickHandler} from "../../utils/onclick";
import { setPasswordAction } from "../../store/control/actions";

let interval;
let timerWithDigitalClock;
export const AnalogClock = memo(function AnalogClock() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [rpc] = useRPC();
    const [state, setState] = useState(new Date());
    const passStatus = useSelector((state) => state.control.passwordStatus);

    useEffect(() => {
        interval = setInterval(() => {
            const time = new Date();
            setState(time);
        }, 1000);
        return () => {
          clearInterval(interval);
        };
    },[])
    
    useEffect(() => {
      timerWithDigitalClock = setInterval(() => {
        history.push("/analog-clock");
      }, 60000);
      return () => {
        clearInterval(timerWithDigitalClock);
      };
    }, [history, dispatch]);

    const hideAnalog = useCallback(() => {
      clearInterval(interval);
      clearInterval(timerWithDigitalClock);
      dispatch(setScreenSaverStatusAction(""));

      if (passStatus === false) {
        history.push("/lock");
        dispatch(setPasswordAction(null));
      } else {
        history.push("/");
      }

      rpc.touchEvent().then();
    }, [history, passStatus, dispatch, rpc]);

    return (
        <div className="analog-clock"  {...onClickHandler(hideAnalog)}>
            <div className="clock">
                <div
                    className="hour_hand"
                    style={{
                        transform: `rotateZ(${state.getHours() * 30}deg)`,
                    }}
                />
                <div
                    className="min_hand"
                    style={{
                        transform: `rotateZ(${state.getMinutes() * 6}deg)`,
                    }}
                />
                <div
                    className="sec_hand"
                    style={{
                        transform: `rotateZ(${state.getSeconds() * 6}deg)`,
                    }}
                />
                <span className="twelve">12</span>
                <span className="one">1</span>
                <span className="two">2</span>
                <span className="three">3</span>
                <span className="four">4</span>
                <span className="five">5</span>
                <span className="six">6</span>
                <span className="seven">7</span>
                <span className="eight">8</span>
                <span className="nine">9</span>
                <span className="ten">10</span>
                <span className="eleven">11</span>
            </div>
        </div>
    );
});
